// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component, OnInit, OnDestroy, AfterViewInit, Input, TemplateRef, ViewChild, Output, EventEmitter, HostBinding } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatSnackBar, MatDialog } from '@angular/material';
import { fadeInOut } from '../../services/animations';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AccountService } from "../../services/account.service";
import { Car } from 'src/app/models/car.model';
import * as FileSaver from 'file-saver'; 

@Component({
    selector: 'car',
    templateUrl: './car.component.html',
    styleUrls: ['./car.component.scss'],
    animations: [fadeInOut]
})

export class CarComponent
{
  private isSaving: boolean;
  private isNew: boolean;
  carForm: FormGroup;
  car: Car;
  definireCar: boolean = false;

  make: string = '';
  model: string = '';
  displayedColumns = ['category', 'make', 'model', 'body', 'variant', 'wheelbase', 'height', 'transmission', 'reference', 'exceptions', 'exceptions2', 'modelAccess', 'actions'];
  isDataLoaded: boolean = false;
  loadingIndicator: boolean = true;
  formResetToggle: boolean = true;
  _currentUserId: string;
  data: Car[];
  dataSource: MatTableDataSource<Car>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  afiseazaDate() {
    this.loadingIndicator = true;

    let make = this.make == null || this.make == "" ? "undefined" : this.make;
    let model = this.model == null || this.model == "" ? "undefined" : this.model;
    
    this.accountService
      .getCarsList(make, model)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.data = liniiReconverted;

        this.dataSource.data = this.data;

        this.isDataLoaded = true;

        setTimeout(() => { this.loadingIndicator = false; }, 1500);

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
        error => {
        });

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  reset() {
    this.make = '';
    this.model = '';
    this.afiseazaDate();
  }

  modificare(car: Car) {
    this.definireCar = true;
    this.car = car;
  }

  verificareStergere(car: Car) {
    this.alertService.showDialog('Delete', 'Do you confirm the deletion?', DialogType.confirm, () => this.stergeCar(car));
  }

  stergeCar(car: Car) {
    car.status = "D";
    this.accountService.saveCar(car).subscribe(
      role => {
        this.saveSuccessHelper(this.car, `Vehicle deleted!`);
        this.afiseazaDate();
      },
      error => this.saveFailedHelper(error));
  }

  adaugare() {
    this.definireCar = true;
    this.car = new Car();
  }
  
  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
  )
  {
    this.dataSource = new MatTableDataSource<Car>();
    this.buildForm();
  }

  ngOnInit() {
    this.car = new Car();
    this.afiseazaDate();
  }
  
  save() {
    if (this.carForm.valid) {
      this.accountService.saveCar(this.car).subscribe(
        role => this.saveSuccessHelper(this.car, `Vehicle saved successfully!`),
        error => this.saveFailedHelper(error));
    }
  }

  private saveSuccessHelper(car?: Car, mesaj?: string) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();

    this.alertService.showMessage("Success", mesaj, MessageSeverity.success);

    this.definireCar = false;
    this.afiseazaDate();
  }

  private saveFailedHelper(error: any) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Save Error", "Errors: ", MessageSeverity.error, error);
    this.alertService.showStickyMessage(error, null, MessageSeverity.error);
  }

  private buildForm() {
    this.carForm = this.formBuilder.group({
      tbCategory: ['', [Validators.required], ],
      tbMake: ['', [Validators.required],],
      tbModel: ['', [Validators.required],],
      tbBody: ['', [Validators.required],],
      tbVariant: ['', [Validators.required],],
      tbWheelbase: ['', [Validators.required],],
      tbHeight: ['', [Validators.required],],
      tbDimensions: ['', [Validators.required],],
      tbLoadingspace: ['', [Validators.required],],
      tbWheellayout: ['', [Validators.required],],
      tbTransmission: ['', [Validators.required],],
      tbReference: ['', [Validators.required],],
      tbExceptions: [''],
      tbExceptions2: [''],
      tbModelAccess: ['', [Validators.required],],
    });
  }

  get tbCategory() {
    return this.carForm.get('tbCategory');
  }

  get tbMake() {
    return this.carForm.get('tbMake');
  }

  get tbModel() {
    return this.carForm.get('tbModel');
  }

  get tbBody() {
    return this.carForm.get('tbBody');
  }

  get tbVariant() {
    return this.carForm.get('tbVariant');
  }

  get tbWheelbase() {
    return this.carForm.get('tbWheelbase');
  }

  get tbHeight() {
    return this.carForm.get('tbHeight');
  }

  get tbDimensions() {
    return this.carForm.get('tbDimensions');
  }

  get tbLoadingspace() {
    return this.carForm.get('tbLoadingspace');
  }

  get tbWheellayout() {
    return this.carForm.get('tbWheellayout');
  }

  get tbTransmission() {
    return this.carForm.get('tbTransmission');
  }
  
  get tbReference() {
    return this.carForm.get('tbReference');
  }
  
  get tbExceptions() {
    return this.carForm.get('tbExceptions');
  }

  get tbExceptions2() {
    return this.carForm.get('tbExceptions2');
  }

  get tbModelAccess() {
    return this.carForm.get('tbModelAccess');
  }

  private cancel() {
    this.definireCar = false;
    this.afiseazaDate();
  }
}
